<template>
    <div>
        <el-card style='margin-top: 2rem;' class='box-card'>
            <div slot='header' class='clearfix'>
                <h3>{{ $t('account.email') || '邮箱' }}</h3>
            </div>
            <!-- 换绑邮箱 -->
            <div v-if='updateEmailStatus && userInfo.email'>
                <div v-if='!captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyEmail' :rules='rules' :model='captchaInfo'
                             label-width='80px'>
                        <el-form-item :label="$t('login.verifyCode') || '验证码'" prop='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                      :placeholder="$t('account.enterVerifyCode') || '请输验证码'" />
                            &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                                   @click='sendEmailCaptchaByAccount'>
                            {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                            }}
                        </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' size='mini' @click='verifyCaptcha'>{{ $t('common.verify') || '验证'
                                }}
                            </el-button>
                            <el-button type='info' size='mini' @click='closeEmailUpdate'>{{ $t('common.close') || '关闭'
                                }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if='captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyEmail' :rules='rules' :model='captchaInfo'
                             label-width='80px'>
                        <el-form-item :label="$t('account.newEmail') || '新邮箱'" key='email' prop='email'>
                            <el-input v-model='captchaInfo.email'
                                      :placeholder="$t('account.enterNewEmail') || '请输入新邮箱'" />
                        </el-form-item>
                        <el-form-item :label="$t('login.verifyCode') || '验证码'" key='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                      :placeholder="$t('login.enterVerifyCode') || '请输入验证码'" />
                            &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                                   @click='sendCaptchaByEmail("changeMyEmail")'>
                            {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                            }}
                        </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button :disabled='!captchaInfo.sendCaptchaStatus' type='primary' size='mini'
                                       @click='updateOrAddEmail("changeMyEmail")'>{{ $t('common.confirm') || '确定' }}
                            </el-button>
                            <el-button type='info' size='mini' @click='closeEmailUpdate'>{{ $t('common.close') || '关闭'
                                }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
            <!-- 添加邮箱 -->
            <div v-if='updateEmailStatus && !userInfo.email'>
                <el-form label-position='left' ref='addNewEmail' :rules='rules' :model='captchaInfo' label-width='80px'>
                    <el-form-item :label="$t('account.email') || '邮箱'" key='email' prop='email'>
                        <el-input v-model='captchaInfo.email' :placeholder="$t('account.enterEmail') || '请输入邮箱'" />
                    </el-form-item>
                    <el-form-item :label="$t('login.verifyCode') || '验证码'" key='captcha'>
                        <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                  :placeholder="$t('login.enterVerifyCode') || '请输入验证码'" />
                        &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                               @click='sendCaptchaByEmail("addNewEmail")'>
                        {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                        }}
                    </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type='primary' size='mini' @click='updateOrAddEmail("addNewEmail")'>
                            {{ $t('common.confirm') || '确定' }}
                        </el-button>
                        <el-button type='info' size='mini' @click='closeEmailUpdate'>{{ $t('common.close') || '关闭'
                            }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            
            <!--展示邮箱-->
            <el-form v-if='!updateEmailStatus' label-position='left' inline>
                <el-form-item :label="$t('account.email') || '邮箱'" prop='age'>
                    <p>{{ userInfo.email }}</p>
                </el-form-item>
                <el-form-item>
                    <el-button @click='updateEmailStatus = true' type='text'>
                        {{ userInfo.email ? ($t('common.unbind') || '换绑') : ($t('common.bind') || '绑定') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'AddOrUpdateEmail',
    props: {
        userInfo: {
            type: Object
        }
    },
    data() {
        return {
            updateEmailStatus: false,
            captchaInfo: {
                captcha: '',
                resendTime: 60,
                email: undefined,
                verifyStatus: false,
                sendCaptchaStatus: false
            },
            rules: {
                email: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('account.enterEmail') || '请输入邮箱'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                captcha: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            time: undefined
        };
    },
    created() {
    },
    methods: {
        sendCaptchaByEmail(formName) {
            if (this.captchaInfo.sendCaptchaStatus) {
                return;
            }
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                accountApi.sendCaptchaByEmail({ email: this.captchaInfo.email }).then(result => {
                    if (result.code === 200) {
                        this.captchaInfo.sendCaptchaStatus = true;
                        this.time = setInterval(() => {
                            if (this.captchaInfo.resendTime <= 1) {
                                clearInterval(this.time);
                                this.captchaInfo.resendTime = 60;
                                this.captchaInfo.sendCaptchaStatus = false;
                            } else {
                                this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1;
                            }
                        }, 1000);
                        message.success(this.$t('account.codeSentCheckEmail') || '验证码已发送，请检查邮箱');
                    }
                });
            });
        },
        updateOrAddEmail(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                accountApi.updateOrAddEmail({
                    userId: this.userInfo.userId,
                    email: this.captchaInfo.email,
                    captcha: this.captchaInfo.captcha
                }).then(result => {
                    if (result.code === 200) {
                        if (this.time) {
                            clearInterval(this.time);
                        }
                        this.updateEmailStatus = false;
                        this.userInfo.email = this.captchaInfo.email;
                        this.resetCaptchaInfo();
                        if (this.userInfo.email) {
                            message.success(this.$t('account.unbindSuccess') || '换绑成功');
                        } else {
                            message.success(this.$t('account.bindSuccess') || '绑定成功');
                        }
                    }
                });
            });
        },
        sendEmailCaptchaByAccount() {
            accountApi.sendEmailCaptchaByAccount({ account: this.userInfo.account }).then(result => {
                if (result.code === 200) {
                    message.success(this.$t('account.codeSentCheckBoundEmail') || '验证码已发送，请检查该账号绑定的邮箱');
                    this.captchaInfo.sendCaptchaStatus = true;
                    this.time = setInterval(() => {
                        if (this.captchaInfo.resendTime <= 1) {
                            clearInterval(this.time);
                            this.captchaInfo.resendTime = 60;
                            this.captchaInfo.sendCaptchaStatus = false;
                        } else {
                            this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1;
                        }
                    }, 1000);
                }
            });
        },
        verifyCaptcha() {
            if (!this.captchaInfo.captcha) {
                message.error(this.$t('login.enterVerifyCode') || '请输入验证码');
                return;
            }
            accountApi.checkEmailCaptcha({
                email: this.userInfo.email,
                captcha: this.captchaInfo.captcha
            }).then(result => {
                if (result.code === 200) {
                    if (this.time) {
                        clearInterval(this.time);
                    }
                    this.captchaInfo.captcha = undefined;
                    this.captchaInfo.email = undefined;
                    this.captchaInfo.verifyStatus = true;
                    this.captchaInfo.sendCaptchaStatus = false;
                    this.captchaInfo.resendTime = 60;
                }
            });
        },
        closeEmailUpdate() {
            clearInterval(this.time);
            this.updateEmailStatus = false;
            this.resetCaptchaInfo();
        },
        resetCaptchaInfo() {
            this.captchaInfo = {
                captcha: '',
                resendTime: 60,
                email: undefined,
                verifyStatus: false,
                sendCaptchaStatus: false
            };
        }
    }
});
</script>

<style scoped lang='css'>
.account-input {
    width: 40%;
}
</style>
